<template>
    <component
        :is="selectedLayout"
        :bundle="myBundleData"
        @bundle-clicked="bundleClicked"
    >
    </component>
</template>

<script>
    import PreviewComponent from "./PreviewComponent";
    import BundlePurchaseComponent from "../../components/pagesbuilder/dynamic-components/BundlePurchaseComponent";
    import BundlePurchaseLayout1 from "../../author/pagesbuilder/templates/cards/BundlePurchaseLayout1";
    import BundlePurchaseLayout2 from "../../author/pagesbuilder/templates/cards/BundlePurchaseLayout2";
    export default {
        name: "PreviewBundlePurchaseComponent",
        mixins: [
            PreviewComponent,
            BundlePurchaseComponent
        ],
        methods: {
            bundleClicked (bundle) {
                window.location.href = `/payment?product_id=${bundle.titleId}&type=bundle`;
            }
        },
        components: {
            BundlePurchaseLayout1,
            BundlePurchaseLayout2,
        }
    }
</script>

